import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'

const styles = theme => ({
  termsAndConditions: {
    maxWidth: 300,
    margin: '0 auto',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    textAlign: 'center',
    '& > a': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBolder,
      textDecoration: 'none',
    },
  },
})

class STGTermsAndConditions extends React.PureComponent {
  render() {
    const { className, showSignUp, classes } = this.props

    if (!showSignUp) return null

    return (
      <div className={cn(classes.termsAndConditions, className)}>
        By clicking Login or Sign Up, you agree to the GameDay{' '}
        <a href="https://mygameday.app/privacy-policy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
    )
  }
}

STGTermsAndConditions.defaultProps = {
  showSignUp: true,
}

export default withStyles(styles)(STGTermsAndConditions)
